// Builds the grouped react-select options (an "All Schools" entry plus
// Schools/Postcodes groups) used by both the map's and the table's filter
// dropdowns, so the two can't drift out of sync with each other.
export const buildFilterOptions = (features) => {
  const schools = new Set();
  const postcodes = new Set();

  features.forEach((feature) => {
    schools.add(feature.properties.school);
    postcodes.add(feature.properties.postcode);
  });

  const createOption = (value) => ({
    value,
    label: value === "" ? "Not specified" : value,
  });

  const sortByLabel = (a, b) => a.label.localeCompare(b.label);

  const schoolOptions = Array.from(schools)
    .filter((item) => item)
    .map(createOption)
    .sort(sortByLabel);

  const postcodeOptions = Array.from(postcodes)
    .filter((item) => item)
    .map(createOption)
    .sort(sortByLabel);

  return [
    { value: "all", label: "All Schools" },
    { label: "Schools", options: schoolOptions },
    { label: "Postcodes", options: postcodeOptions },
  ];
};
